import { render, staticRenderFns } from "./MarketPolygonLabel.vue?vue&type=template&id=58314a76"
import script from "./MarketPolygonLabel.vue?vue&type=script&lang=js"
export * from "./MarketPolygonLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports